import axios from 'axios';

import {
  errorReasonTable,
  errorTable,
} from '@/shared/constants';

export function getErrorReasonMessage (error?: unknown): string | undefined {
  if (!axios.isAxiosError(error)) {
    return undefined;
  }

  const reason = error.response?.data?.reason;
  const errorByReason = typeof reason === 'string' ? errorReasonTable[reason] : undefined;

  return typeof errorByReason === 'string' ? errorByReason : undefined;
}

export function getErrorMessageTyped (
  error?: unknown,
  fallback = 'Произошла ошибка. Попробуйте через несколько минут',
): string {
  const errorByReason = getErrorReasonMessage(error);

  if (errorByReason != null) {
    return errorByReason;
  }

  if (axios.isAxiosError(error)) {
    const status = Number(error.response?.status);
    const errorByStatus = errorTable[status];

    if (errorByStatus != null) {
      return errorByStatus;
    }

    const preparedFallback = error.response?.status
      ? `${ fallback } (${ error.response?.status })`
      : fallback;

    let errorMessage = error.message;

    if (!errorMessage || errorMessage === 'Network Error') {
      errorMessage = preparedFallback;
    }

    return error.response?.data?.message
      || errorMessage;
  }

  return fallback;
}

export default getErrorMessageTyped;
